export default "__VITE_ASSET__VwTS5VFY__"